import { Icon, Typography } from '@mui/material';
import { Tooltip } from '@mui/material';
import { CalendarAttentionIcon, CopyAction } from '@schooly/style';
import { FC } from 'react';
import { useIntl } from 'react-intl';

export const AbsenceNoticeInfo: FC<{ comment: string }> = ({ comment }) => {
  const { formatMessage } = useIntl();

  return (
    <Tooltip
      componentsProps={{ tooltip: { sx: { padding: 1.25, width: 200 } } }}
      title={
        <>
          <Typography variant="h4" mb={0.5} color="text.secondary">
            {formatMessage({ id: 'attendance-AbsenceNotice' })}
          </Typography>
          <Typography color="inherit" maxHeight={350} overflow="auto">
            {comment}
          </Typography>
          <CopyAction pt={1.25} onCopy={() => navigator.clipboard.writeText(comment)} />
        </>
      }
    >
      <Icon sx={(theme) => ({ color: theme.palette.common.orange })}>
        <CalendarAttentionIcon />
      </Icon>
    </Tooltip>
  );
};
